<script setup>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  attribute: {
    type: Object,
    default: null
  },
  deleting: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close', 'confirm'])

function confirmDelete() {
  if (props.attribute?.id) {
    emit('confirm', props.attribute.id)
  }
}

function closeDialog() {
  if (props.deleting) return
  emit('close')
}
</script>

<template>
  <Dialog
    :visible="props.visible"
    modal
    header="Удалить атрибут?"
    :closable="!props.deleting"
    :style="{ width: 'min(400px, 95vw)' }"
    @update:visible="closeDialog"
  >
    <div class="dialog-content">
      <p>
        Вы точно хотите удалить
        "<strong>{{ props.attribute?.name || '—' }}</strong>"?
      </p>
    </div>

    <template #footer>
      <div class="dialog-buttons">
        <Button
          label="Отмена"
          severity="secondary"
          outlined
          :disabled="props.deleting"
          @click="closeDialog"
        />
        <Button
          label="Удалить"
          icon="pi pi-trash"
          severity="danger"
          :loading="props.deleting"
          :disabled="props.deleting"
          @click="confirmDelete"
        />
      </div>
    </template>
  </Dialog>
</template>

<style scoped>
.dialog-content {
  padding: 8px 0;
  font-size: 14px;
  color: #333333;
  line-height: 1.5;
}

.dialog-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>